import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../../commons/FormatearFecha";
import { CalendarIcon } from "../../../../components/icons/CalendarIcon";
import { DialogWrapper } from "../../../../components/molecules/DialogWrapper";
import { DateRangeContext } from "../context/DateRangeContext";
import { CustomDateRangePicker } from "./DateRangePicker";

function formatSelectedDates(language, startDate, endDate) {
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  const locales = language === "es" ? "es-CL" : "en-US";
  const formatedStartDate = formatDate(startDate, locales, options);
  const formatedEndDate = formatDate(endDate, locales, options);

  if (formatedStartDate === formatedEndDate) return formatedStartDate;

  return `${formatedStartDate} - ${formatedEndDate}`;
}

export const DialogDateRangePicker = ({ isScrolled }) => {
  const { i18n } = useTranslation();
  const { finalDate } = useContext(DateRangeContext);

  const language = i18n.language;

  const { startDate, endDate } = finalDate;

  const formattedSelectedDates = formatSelectedDates(
    language,
    startDate,
    endDate
  );

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <section>
      <button
        className="btn-open-dialog-date-picker"
        data-is-scrolled={isScrolled}
        onClick={handleOpen}>
        <CalendarIcon />
        <p>{formattedSelectedDates}</p>
      </button>
      <DialogWrapper
        open={open}
        onClose={handleClose}>
        <CustomDateRangePicker handleCloseDialog={handleClose} />
      </DialogWrapper>
    </section>
  );
};
